import { render, staticRenderFns } from "./board-view-images.vue?vue&type=template&id=6c712b57&"
import script from "./board-view-images.vue?vue&type=script&lang=js&"
export * from "./board-view-images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports